export const courseTabsClasses = {
  root: "CourseTabs-root",
  tabList: "CourseTabs-tabList",
  nav: "CourseTabs-nav",
  navTitle: "CourseTabs-navTitle",
  tabItem: "CourseTabs-tabItem",
  tabItemArrow: "CourseTabs-tabItemArrow",
  modificationButtonsRoot: "CourseTabs-modificationButtonsRoot",
  addItemButton: "CourseTabs-addItemButton",
  content: "CourseTabs-content",
  contentType: (type: "conversation" | "question") => `CourseTabs-content-${type}`,
  tabItemArrowDir: (dir: "start" | "end") => `CourseTabs-tabItemArrow-${dir}`,
  depth: (n: number) => `CourseTabs-depth-${n}`,
} as const;
